module.exports = __webpack_public_path__ + "static/img/b1.addd8c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b1.jpg
// module id = PPFf
// module chunks = 1